<template>
  <div class="row">
    <div class="col-12">
      <!-- <page-header>
        <template slot="action-buttons">
          <div v-if="isCopyMode">
            <div v-if="isSaving" class="loader-wrapper">
              <Loader />
            </div>
            <div v-else>
              <b-button variant="primary" size="sm" @click="disableCopyMode">
                {{ 'Cancel' | i18n }}
              </b-button>
              <b-button variant="primary" size="sm" @click="saveCopyMode">
                {{ 'Save' | i18n }}
              </b-button>
            </div>
          </div>
          <div v-else>
            <b-button variant="primary" size="sm" @click="enableCopyMode">
              {{ 'Copy mode' | i18n }}
            </b-button>
          </div>
        </template>
      </page-header> -->
      <div class="d-flex justify-content-end mb-3">
        <div v-if="isCopyMode">
          <div v-if="isSaving" class="loader-wrapper">
            <Loader />
          </div>
          <div v-else>
            <b-button variant="primary" size="sm" @click="disableCopyMode">
              {{ 'Cancel' | i18n }}
            </b-button>
            <b-button variant="primary" size="sm" @click="saveCopyMode">
              {{ 'Save' | i18n }}
            </b-button>
          </div>
        </div>
        <div v-else>
          <b-button variant="primary" size="sm" @click="enableCopyMode">
            {{ 'Copy mode' | i18n }}
          </b-button>
        </div>
      </div>
      <div class="row poppins">
        <div class="col-12">
          <div class="shift-header-wrapper">
            <EditCell :generateShift="generateShift" :cell="selectedCell" />
            <div class="shift-header-box">
              <div class="shift-header-block">
                <span class="team-name">{{ 'Team' | i18n }}: {{ team.name }}</span>
                <span>{{ 'Attendance and holiday planning' | i18n }}:</span>
              </div>
              <div class="arrow-btn" @click="pressArrowMonth(-1)">
                <BIconArrowLeft />
              </div>
              <div class="shift-header-date">
                <span @click="showMonthPicker = !showMonthPicker">
                  {{ moment(selectedDate, 'YYYY-MM').format('MMMM') | i18n }} {{ moment(selectedDate, 'YYYY-MM').format('YYYY') }}
                </span>
                <div v-if="showMonthPicker" class="mounth-picker">
                  <div class="mounth-picker-year">
                    <span class="mounth-picker-year-arrow" @click="() => subtractYear()" v-text="'<'" />
                    <span class="total-center">{{ moment(preSelectedDate, 'YYYY-MM').format('YYYY') | i18n }}</span>
                    <span class="mounth-picker-year-arrow" @click="() => addYear()">{{ '>' }}</span>
                  </div>
                  <div class="mounth-picker-month-box">
                    <div
                      v-for="(month, index) in moment.months()"
                      :key="month"
                      class="mounth-picker-month"
                      :style="`${
                        moment(preSelectedDate, 'YYYY-MM').format('YYYY') === moment(selectedDate, 'YYYY-MM').format('YYYY') &&
                        index === moment(selectedDate, 'YYYY-MM').format('MM') - 1
                          ? 'background:#2260FF;color:white;'
                          : ''
                      }`"
                      @click="() => selectMonth(index)"
                    >
                      {{ month | i18n }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="arrow-btn" @click="pressArrowMonth(1)">
                <BIconArrowRight />
              </div>
            </div>
            <div class="arrows-block">
              <div class="arrow-btn arrow-btn-pdf" @click="exportShiftToPDF()">
                {{ 'PDF' | i18n }}
              </div>
              <div class="arrow-btn" @click="scrollShift(-600)">
                <BIconArrowLeft />
              </div>
              <div class="arrow-btn" @click="scrollShift(600)">
                <BIconArrowRight />
              </div>
            </div>
          </div>
          <div v-if="loadingPDF" class="pdf-loader">
            <Loader />
          </div>
          <div :class="styleForPDF ? 'pdf-wrapper' : 'table-wrapper mt-2'">
            <Loader v-if="!shiftLoaded" />
            <div v-else class="height100">
              <Table
                :shift="shift"
                :selectCell="selectCell"
                :selectDate="selectDate"
                :isCopyMode="isCopyMode"
                :selectedCopyDay="selectedCopyDay"
                :selectCopyDay="selectCopyDay"
                :selectPasteDay="selectPasteDay"
                :shiftColors="shiftColors"
                :absenceColors="absenceColors"
                tableName="teamShiftPlanTable"
                :styleForPDF="styleForPDF"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BIconArrowRight, BIconArrowLeft } from 'bootstrap-vue';
import html2pdf from 'html2pdf.js';

import { NotificationMixin } from '../../../../mixins';
import api from '../../../api';
import Notification from '../../common/notification';

import moment from 'moment';
import Loader from '../../common/loader';
import PageHeader from '../../common/page-header';
import EditCell from './edit-cell';
import { SHIFTS } from '../../../../../../../constants';

import Table from './table.vue';

export default {
  title: 'TeamShiftPlan',
  components: { Loader, PageHeader, Table, EditCell, BIconArrowRight, BIconArrowLeft },
  mixins: [NotificationMixin],
  data() {
    return {
      isSaving: false,
      selectedPasteDay: {},
      selectedCopyDay: null,
      isCopyMode: false,
      showMonthPicker: false,
      selectedDate: moment().format('YYYY-MM'),
      preSelectedDate: moment().format('YYYY-MM'),
      shift: null,
      shitTemplate: null,
      operationalArea: null,
      selectedTeam: null,
      shiftLoaded: false,
      moment: moment,
      SHIFTS: SHIFTS,
      selectedColumn: {},
      startDay: null,
      selectedCell: {},
      type: 'table',
      team: {},
      shiftColors: {},
      absenceColors: {},
      shiftPositions: [],
      loadingPDF: false,
      styleForPDF: false,
    };
  },
  async created() {
    this.initShift();
  },
  methods: {
    exportShiftToPDF() {
      this.loadingPDF = true;
      this.styleForPDF = true;
      setTimeout(() => {
        const element = document.getElementById(`table-pdf-format`);
        console.log(element, 'element');
        var opt = {
          margin: 0,
          filename: `${this.team.name}_${moment(this.selectedDate, 'YYYY-MM').format('YYYY-MM')}.pdf`,
          html2canvas: { scale: 4 },
          jsPDF: { unit: 'in', format: 'a4', orientation: 'landscape' },
        };
        html2pdf().from(element).set(opt).save();
        this.styleForPDF = false;
        this.loadingPDF = false;
      }, 1000);
    },
    scrollShift(offset) {
      document.querySelector('.shift-block').scrollLeft += offset;
    },
    selectPasteDay(column, user) {
      if (column.frozen[user.id]) {
        return;
      }
      const n = `${column.date}_${user.id}`;

      this.selectedPasteDay[n] = this.selectedPasteDay[n]
        ? false
        : {
            date: column.date,
            user,
          };
      this.generateShift();
    },
    selectCopyDay(column, user) {
      this.selectedCopyDay = {
        shiftDetails: column.shiftDetails[user.id] || {},
        shiftPositions: column.shiftPositions[user.id] || {},
      };
    },
    disableCopyMode() {
      this.selectedCopyDay = null;
      this.selectedPasteDay = {};
      this.isCopyMode = false;
      this.generateShift();
    },
    enableCopyMode() {
      this.isCopyMode = true;
    },
    async saveCopyMode() {
      this.isSaving = true;
      const dates = {};

      Object.values(this.selectedPasteDay).forEach((d) => {
        if (!d) {
          return;
        }

        if (!dates[d.date]) {
          dates[d.date] = {
            date: d.date,
            users: [],
          };
        }
        dates[d.date].users.push(d.user);
      });
      console.log(dates, 'dates');
      for (const key in dates) {
        await this.saveCopyCell(dates[key]);
      }
      this.generateShift();
      this.disableCopyMode();
      this.isSaving = false;
    },
    async saveCopyCell(cell) {
      console.log(cell, 'cell');
      let users = this.team.users;

      const shiftDay = this.shiftDaysObj[cell.date];

      if (shiftDay && shiftDay.team) {
        users = shiftDay.team.users;
      }
      const copy = this.selectedCopyDay;

      const userData = {
        shiftPosition: this.shiftPositions ? this.shiftPositions.find((p) => p.id == copy.shiftPositions.id) : null,
        shiftDetails: {
          absence: copy.shiftDetails.absence || null,
          // workingHours: copy.shiftDetails.workingHours || null,
          payInformation: copy.shiftDetails.payInformation || null,
          comment: copy.shiftDetails.comment || null,
        },
      };

      cell.users.forEach((user) => {
        let exist = false;

        users = users.map((u) => {
          if (u.id === user.id) {
            exist = true;
            return {
              ...u,
              ...userData,
            };
          }
          return u;
        });

        if (!exist) {
          users.push({
            ...user,
            ...userData,
          });
        }
      });

      const data = {
        date: cell.date,
        operationalArea: this.operationalArea,
        teamId: this.team.id,
        users,
      };
      console.log(data, 'data');
      await api.shiftDay.save(data);
    },
    selectDate(shift, date) {
      const data = {
        operationalAreaId: this.operationalArea.id,
        date,
        shift,
        teamID: this.selectedTeam,
      };
      this.$router.push({ name: 'shift-day', query: data });
    },
    selectCell(column, user) {
      if (column.frozen[user.id]) {
        return;
      }
      this.selectedCell = {
        date: column.date,
        shift: column.shift,
        operationalArea: this.operationalArea,
        shiftDetails: column.shiftDetails[user.id],
        shiftPosition: column.shiftPositions[user.id],
        user,
        shiftDay: this.shiftDaysObj[column.date],
        team: this.team,
      };
      setTimeout(() => {
        this.$root.$emit('bv::show::modal', 'edit-cell');
      }, 1);
    },
    async selectMonth(m) {
      this.selectedDate = moment(this.preSelectedDate, 'YYYY-MM').set({ months: m }).format('YYYY-MM');

      this.showMonthPicker = false;
      this.generateShift();
    },
    async pressArrowMonth(value) {
      if (value > 0) {
        this.selectedDate = moment(this.preSelectedDate, 'YYYY-MM').add(1, 'month').format('YYYY-MM');
      } else {
        this.selectedDate = moment(this.preSelectedDate, 'YYYY-MM').subtract(1, 'month').format('YYYY-MM');
      }
      this.preSelectedDate = this.selectedDate;

      this.showMonthPicker = false;
      this.generateShift();
    },
    addYear() {
      this.preSelectedDate = moment(this.preSelectedDate, 'YYYY-MM').add(1, 'years').format('YYYY-MM');
    },
    subtractYear() {
      this.preSelectedDate = moment(this.preSelectedDate, 'YYYY-MM').subtract(1, 'y').format('YYYY-MM');
    },
    async initShift() {
      try {
        const q = this.$route.query;
        this.operationalArea = await api.operationalArea.getById(q.operationalAreaId);
        this.selectedDate = q.date;
        this.selectedTeam = this.$route.params.teamId;

        if (!this.operationalArea || !this.selectedDate || !this.selectedTeam) {
          Notification({ type: 'error', message: 'Wrong data' });
          return;
        }

        const shitTemplate = await api.shiftTemplate.get({ operationalArea: this.operationalArea.id });
        if (!shitTemplate || !shitTemplate[0]) {
          Notification({ type: 'error', message: 'Shift template not found.' });
          return;
        }

        const settings = await api.settings.getSettings();
        this.shiftColors = settings.shiftColors;
        this.absenceColors = settings.absenceColors;
        this.shitTemplate = shitTemplate[0];
        let startDay = settings.scheduleStartDate;
        if (!startDay) {
          Notification({ type: 'error', message: 'No start date. Please set the start date in the settings.' });
          return;
        }
        this.startDay = moment(startDay).format('YYYY-MM-DD');

        this.shiftPositions = await api.shiftPositions.get({ operationalArea: this.operationalArea.id });

        await this.generateShift();
        this.shiftLoaded = true;
      } catch (err) {
        Notification({ type: 'error', message: err.message });
      }
    },
    async generateShift() {
      const currentMonth = moment(this.selectedDate).set('date', 1).format('YYYY-MM-DD');
      const difference = moment(currentMonth).diff(moment(this.startDay), 'days');
      const team = this.shitTemplate.teams.find((t) => t.id == this.selectedTeam);
      this.team = Object.assign({}, team);

      if (!team || !team.id) {
        Notification({ type: 'error', message: 'Team not found' });
        return;
      }

      const m = moment(this.selectedDate);

      const shiftDays = await api.shiftDay.get({
        year: m.format('YYYY'),
        month: m.format('MM'),
        teamId: this.selectedTeam,
        operationalArea: this.operationalArea.id,
      });

      const users = [
        ...team.users.filter((u) => {
          if (u.startWorkingDate) {
            return m.isSameOrAfter(moment(u.startWorkingDate).format('YYYY-MM'));
          } else {
            return true;
          }
        }),
      ];
      const userIds = users.map((u) => u.id);

      const teamPositions = {};
      team.users.forEach((u) => {
        if (u.shiftPosition) {
          teamPositions[u.id] = u.shiftPosition;
        }
      });

      const shiftDaysObj = {};
      if (shiftDays) {
        shiftDays.forEach((shift) => {
          shiftDaysObj[shift.date] = shift;
          shift.team.users.forEach((u) => {
            if (!userIds.includes(u.id)) {
              users.push({
                ...u,
                notFromTeam: true,
              });
              userIds.push(u.id);
            }
          });
        });
      }
      this.shiftDaysObj = shiftDaysObj;
      const base = {
        users,
        columns: Array.from({ length: moment(this.selectedDate).daysInMonth() }).map((_, i) => {
          const y = Math.abs((i + difference) % Object.keys(this.shitTemplate.template).length) + 1;

          const m = moment(this.selectedDate).set('date', i + 1);
          const date = m.format('YYYY-MM-DD');

          const shift = shiftDaysObj[date] || {};
          const shiftPositions = {};
          const shiftDetails = {};
          const shiftName = this.shitTemplate.template[y][team.id];

          const dayUsers = shift.team ? shift.team.users : team.users;
          let frozen = {};
          let isPasted = {};

          dayUsers.forEach((u) => {
            if (u.startWorkingDate && m.isBefore(moment(u.startWorkingDate))) {
              frozen[u.id] = true;
              return;
            }

            const isTeamPosition = shiftName !== SHIFTS.OFF_SHIFT;

            if (shift && shift.team) {
              shiftPositions[u.id] = u.shiftPosition || (isTeamPosition ? teamPositions[u.id] : null);
              shiftDetails[u.id] = u.shiftDetails || {};
            } else {
              shiftPositions[u.id] = isTeamPosition ? teamPositions[u.id] : null;
              shiftDetails[u.id] = {};
            }
            if (!shiftDetails[u.id].workingHours && this.shitTemplate.workingHours && shiftName !== SHIFTS.OFF_SHIFT) {
              const dayName = m.format('dddd');
              if (this.shitTemplate.workingHours[dayName]) {
                shiftDetails[u.id].workingHours = this.shitTemplate.workingHours[dayName];
              }
            }
          });

          users.forEach((u) => {
            const isPast = this.selectedPasteDay[`${date}_${u.id}`];
            if (isPast) {
              isPasted[u.id] = true;
              shiftPositions[u.id] = this.selectedCopyDay.shiftPositions;
              const d = this.selectedCopyDay.shiftDetails || {};
              const data = {
                absence: d.absence || null,
                payInformation: d.payInformation || null,
                comment: d.comment || null,
                workingHours: shiftDetails[u.id].workingHours || null,
              };

              shiftDetails[u.id] = data;
            }
          });

          return {
            frozen,
            isPasted,
            date: date,
            shiftPositions,
            shiftDetails,
            shift: shiftName,
          };
        }),
      };
      console.log(base, 'base');
      this.shift = base;
    },
  },
};
</script>

<style lang="scss" scoped>
.height100 {
  height: 100%;
}
.main-content {
  min-height: calc(100vh - 180px);
}
.users-block {
  height: calc(100vh - 200px);
  position: absolute;
}

.add-user-block {
  position: absolute;
  margin-top: -55px;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0px 2px;
}

.add-user-block button {
  width: 100%;
}

.user-line {
  border: 1px solid black;
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 7px;
  margin: 2px;
}

.shift-wrapper {
  min-width: 100%;
  height: calc(100vh - 200px);
  overflow: hidden;
}

.shift-block {
  display: flex;
  flex-wrap: nowrap;
  min-width: 100%;
  height: calc(100vh - 200px);
  overflow: scroll;
}

.shift-cell {
  border: 1px solid black;
  width: 40px;
  height: 40px;
  margin: 2px 2px;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.shift-cell-disabled {
  background: rgb(177, 178, 177);
}

.cell-angle {
  transform: rotate(45deg);
  position: absolute;
}

.cell-angle-bottom {
  border-top: 0.1px solid gray;
  transform: rotate(45deg);
  position: absolute;
}

.cell-status {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.date-cell-action-bace {
  transition: all 1s;
  opacity: 0;
  position: absolute;
  color: white;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.date-cell-action-user {
  transition: all 1s;
  opacity: 0;
  position: absolute;
  color: white;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  width: 97%;
  left: 2px;
}

.date-cell-plus {
  background: #28a745;
}

.date-cell-minus {
  background: #dc3545;
}

.shift-header-wrapper {
  width: 100%;
  background-color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  padding: 10px;
}

.shift-header-block {
  margin-right: 2px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
}

.shift-header-date {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  font-size: 12px;
  background: rgb(34, 96, 255);
  color: white;
  padding: 6px 8px;
  border-radius: 8px;
  font-weight: 400;
  user-select: none;
  min-width: 120px;
}

.create-shift-box {
  display: flex;
  justify-content: center;
  min-height: calc(100vh - 170px);
  align-items: center;
}

.shift-header-box {
  display: flex;
  width: inherit;
}

.mounth-picker {
  position: absolute;
  width: 100%;
  background: white;
  z-index: 100;
  font-weight: 400;
  min-width: 320px;
  border-radius: 8px;
  color: black;
  -webkit-box-shadow: 0px 0px 12px 0px rgba(34, 60, 80, 0.35);
  -moz-box-shadow: 0px 0px 12px 0px rgba(34, 60, 80, 0.35);
  box-shadow: 0px 0px 12px 0px rgba(34, 60, 80, 0.35);
  padding: 10px 10px;
  top: 35px;
}

.mounth-picker-year {
  text-align: center;
  display: flex;
  justify-content: space-around;
  cursor: pointer;
  font-size: 17px;
}

.mounth-picker-year-arrow {
  padding: 0 10px;
}

.mounth-picker-month-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.mounth-picker-month {
  padding: 7px 0;
  cursor: pointer;
  border-radius: 8px;
  width: 33%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.total-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.alert-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  text-align: center;
}

.toogle-wrapper {
  display: flex;
  align-items: center;
  margin-right: 45px;
}

.icon-toogle {
  width: 18px;
  height: 18px;
  margin: 0 5px;
  cursor: pointer;
}

.toogle-body {
  width: 40px;
  height: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding: 0 3px;
  cursor: pointer;
  border: 1px solid #80bdff;
}

.toogle-cycle {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #2260ff;
}

.team-name {
  margin-right: 30px;
}

.loader-wrapper {
  max-height: 20px;
  transform: scale(0.5);
  position: absolute;
  margin-top: -40px;
  margin-left: -40px;
}

.arrows-block {
  display: flex;
  width: 150px;
  justify-content: space-between;
}

.arrow-btn-pdf {
  font-size: 13px !important;
}

.arrow-btn {
  background: #2260ff;
  border-radius: 9px;
  color: white;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 25px;
  user-select: none;
  margin: 0 5px;
}

.pdf-wrapper {
  overflow: hidden;
}
.pdf-loader {
  background: white;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}
</style>
